import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {SyslogApiService} from '../../../services/api/settings/network-services/syslog/syslog-api.service';
import {SyslogTypes} from '../../enums/settingsEnums';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'cdr',
  templateUrl: './cdr.component.html',
  styleUrls: ['./cdr.component.scss']
})
export class CdrComponent implements OnInit, AfterViewInit {
  cdrSettings: any = {};
  protocolOptions: string[] = ['UDP', 'TCP'];
  cdrTypesOptions = [
    {name: 'Clear text'                 , value: 'CDR_AS_CLEAR_TEXT'},
    {name: 'Json'                       , value: 'CDR_AS_JSON'},
    {name: 'Clear text and json'        , value: 'BOTH'}
  ];
  canSubmit: boolean;
  formNotValid = true;
  @ViewChild('mapForm') mapForm: NgForm ;

  constructor(private userPrivilege: UserPrivilegeService,
              private sysLogApiService: SyslogApiService, private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.initialization();
  }

  submit(): void {
    this.sysLogApiService.editSyslog(this.cdrSettings, this.cdrSettings.id).subscribe();
  }


 initialization(): void{
  this.canSubmit = this.userPrivilege.isAuthorized();

  const parameters = {
    filter: {
      sourceType: {
        operator: '=', value: SyslogTypes.CDR
      }
    }
  };
  this.loaderService.showMainContainer();
  this.sysLogApiService.getSyslogs(parameters).subscribe(data => {
    this.cdrSettings = data[0];
    this.loaderService.hideMainContainer();
  });
}

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.formNotValid = (!this.mapForm.form.valid || !this.canSubmit);
    });
  }




}

